var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPackagesBuyout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 122,
    viewBox: "0 0 123 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 122,
    height: 122,
    rx: 61,
    fill: "url(#paint0_linear_4136_297909)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1533 30.6943H36.4265C39.6995 30.6943 42.2754 33.5127 42.0027 36.7554L39.4873 66.9397C39.3891 68.1091 39.5349 69.2861 39.9154 70.3962C40.2958 71.5063 40.9027 72.5253 41.6976 73.3885C42.4925 74.2518 43.4581 74.9405 44.5331 75.4111C45.6081 75.8817 46.7691 76.1239 47.9426 76.1223H80.2179C84.5819 76.1223 88.4004 72.5462 88.7338 68.2126L90.3703 45.4834C90.7339 40.4527 86.9154 36.3615 81.8544 36.3615H42.73M52.3672 48.8776H88.7338M74.3387 91.3053C75.3434 91.3053 76.3069 90.9062 77.0173 90.1958C77.7277 89.4854 78.1268 88.5218 78.1268 87.5172C78.1268 86.5125 77.7277 85.5489 77.0173 84.8385C76.3069 84.1281 75.3434 83.729 74.3387 83.729C73.334 83.729 72.3704 84.1281 71.66 84.8385C70.9496 85.5489 70.5505 86.5125 70.5505 87.5172C70.5505 88.5218 70.9496 89.4854 71.66 90.1958C72.3704 90.9062 73.334 91.3053 74.3387 91.3053ZM50.0943 91.3053C51.0989 91.3053 52.0625 90.9062 52.7729 90.1958C53.4833 89.4854 53.8824 88.5218 53.8824 87.5172C53.8824 86.5125 53.4833 85.5489 52.7729 84.8385C52.0625 84.1281 51.0989 83.729 50.0943 83.729C49.0896 83.729 48.126 84.1281 47.4156 84.8385C46.7052 85.5489 46.3061 86.5125 46.3061 87.5172C46.3061 88.5218 46.7052 89.4854 47.4156 90.1958C48.126 90.9062 49.0896 91.3053 50.0943 91.3053Z",
    stroke: "#0061AF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4136_297909",
    x1: 61.5,
    y1: 0,
    x2: 61.5,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPackagesBuyout);
export default __webpack_public_path__ + "static/media/empty-packages_buyout.a82217252db171e87b9f921bf0cdac20.svg";
export { ForwardRef as ReactComponent };